import { rules } from "@Shared/@Utils/shared-mixins/vuelidate-valid-mixin";
import { computed, watch } from "@vue/composition-api";
import { isEmpty, transform } from "lodash";
export const useInputValidations = validator => {
  const isSoftError = rule => {
    var _validator$value$$par, _validator$value, _validator$value$$par2, _validator$value$$par3;
    if (isEmpty(validator.value)) return false;
    return (_validator$value$$par = (_validator$value = validator.value) == null ? void 0 : (_validator$value$$par2 = _validator$value.$params) == null ? void 0 : (_validator$value$$par3 = _validator$value$$par2[rule]) == null ? void 0 : _validator$value$$par3.softError) != null ? _validator$value$$par : false;
  };
  const getErrorMessage = (rule, value, key) => {
    var _validator$value2, _validator$value2$rul, _validator$value3, _validator$value3$$pa;
    if (typeof value[key] === "function") return value[key](((_validator$value2 = validator.value) == null ? void 0 : (_validator$value2$rul = _validator$value2[rule]) == null ? void 0 : _validator$value2$rul.$params) || ((_validator$value3 = validator.value) == null ? void 0 : (_validator$value3$$pa = _validator$value3.$params) == null ? void 0 : _validator$value3$$pa[rule]));
    return value[key];
  };
  const validationResult = computed(() => {
    const {
      displayError
    } = transform(rules, (acc, value, rule) => {
      var _validator$value4, _validator$value5, _validator$value5$rul;
      if (((_validator$value4 = validator.value) == null ? void 0 : _validator$value4[rule]) === false || (_validator$value5 = validator.value) != null && (_validator$value5$rul = _validator$value5[rule]) != null && _validator$value5$rul.$invalid) {
        const isSoft = isSoftError(rule);
        acc.displayError = {
          isSoft,
          value: getErrorMessage(rule, value, isSoft ? "soft" : "full")
        };
      }
      if (acc.displayError) {
        return false;
      }
    }, {});
    return {
      isSoft: displayError == null ? void 0 : displayError.isSoft,
      message: displayError == null ? void 0 : displayError.value
    };
  });
  const hasError = computed(() => {
    var _validator$value6, _validator$value7;
    return ((_validator$value6 = validator.value) == null ? void 0 : _validator$value6.$dirty) && ((_validator$value7 = validator.value) == null ? void 0 : _validator$value7.$invalid);
  });
  const hasSoftError = computed(() => {
    return validationResult.value.isSoft;
  });
  const errorMessage = computed(() => {
    return validationResult.value.message;
  });
  watch(() => {
    var _validator$value8;
    return (_validator$value8 = validator.value) == null ? void 0 : _validator$value8.$model;
  }, () => {
    var _validator$value9;
    (_validator$value9 = validator.value) == null ? void 0 : _validator$value9.$touch();
  });
  return {
    hasError,
    hasSoftError,
    errorMessage
  };
};